
/* ZUVIE reservation path v1. No cookies, storage, extra requests or pixels.
   Source fields describe supplied URL tags, not verified Meta attribution. */
(function (w, d) {
  'use strict';
  if (w.ZVPath) return;
  var keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content',
    'utm_term', 'utm_id', 'campaign_id', 'adset_id', 'ad_id', 'test_arm'];
  var pages = ['how-much-is-in-it', 'will-it-sting'];

  function permission() {
    try {
      var p = w.Shopify && w.Shopify.customerPrivacy;
      if (!p || typeof p.analyticsProcessingAllowed !== 'function' ||
          typeof p.marketingAllowed !== 'function') return 'unavailable';
      return p.analyticsProcessingAllowed() === true && p.marketingAllowed() === true
        ? 'allowed' : 'not_allowed';
    } catch (_) { return 'unavailable'; }
  }

  function value(params, key) {
    var values = params.getAll(key);
    if (values.length !== 1) return '';
    var v = values[0];
    // Bounded machine tags only: reject emails, links, arbitrary text and macros.
    if (!v || v.length > 160 || !/^[A-Za-z0-9_.~-]+$/.test(v)) return '';
    if (key === 'campaign_id' || key === 'adset_id' || key === 'ad_id') {
      if (!/^\d{6,30}$/.test(v)) return '';
    }
    return v;
  }

  function read() {
    var state = permission();
    var result = { version: '1', status: state, origin_page: 'unknown', tags: {} };
    if (state !== 'allowed') return result;
    var url = new URL(w.location.href);
    var current = url.pathname.split('/').pop();
    var origin = pages.indexOf(current) !== -1 ? current : value(url.searchParams, 'zv_from');
    if (pages.indexOf(origin) !== -1) result.origin_page = origin;
    keys.forEach(function (key) {
      var v = value(url.searchParams, key);
      if (v) result.tags[key] = v;
    });
    result.status = Object.keys(result.tags).length ? 'tagged' : 'untagged';
    return result;
  }

  function fields(snapshot, prefix) {
    var out = {};
    out[prefix + 'version'] = snapshot.version;
    out[prefix + 'status'] = snapshot.status;
    out[prefix + 'origin_page'] = snapshot.origin_page;
    keys.forEach(function (key) { out[prefix + key] = snapshot.tags[key] || 'unknown'; });
    return out;
  }

  function decorate() {
    var links = d.querySelectorAll('a[data-zv-reserve-path]');
    for (var i = 0; i < links.length; i++) {
      var link = links[i];
      // Fixed same-origin destination; never use a URL supplied in a parameter.
      var url = new URL('/pages/reserve-or-join', w.location.origin);
      // Preserve the approved jump to the form; source and consent handling are unchanged.
      if (link.hash === '#reservation-form') url.hash = '#reservation-form';
      var source = read();
      if (source.status === 'tagged' || source.status === 'untagged') {
        Object.keys(source.tags).forEach(function (key) { url.searchParams.set(key, source.tags[key]); });
        if (source.origin_page !== 'unknown') url.searchParams.set('zv_from', source.origin_page);
      }
      link.href = url.pathname + url.search + url.hash;
    }
  }

  w.ZVPath = {
    snapshot: read,
    eventFields: function (snapshot) { return fields(snapshot, 'zv_source_'); },
    profileFields: function (snapshot) { return fields(snapshot, 'zv_last_form_source_'); },
    validEmail: function (email) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email); },
    // Klaviyo deduplicates by profile + metric + unique_id. No identifier in URLs.
    eventId: function (mode) { return 'zuvie-first-launch-' + mode + '-v1'; },
    decorate: decorate
  };
  decorate();
  d.addEventListener('visitorConsentCollected', decorate);
  d.addEventListener('click', function (event) {
    if (event.target && event.target.closest && event.target.closest('a[data-zv-reserve-path]')) decorate();
  }, true);
  if (w.Shopify && !w.Shopify.customerPrivacy && typeof w.Shopify.loadFeatures === 'function') {
    w.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () { decorate(); });
  }
})(window, document);


;

var ZVUS_KEY = "XNpMRQ";
// US list.
var ZVUS_LIST = window.ZVShop.listId;

function zvUsSay(t){ var m = document.getElementById('zvUsMsg'); if (m) m.textContent = t; }

function zvUsPost(path, body){
  return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + ZVUS_KEY, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
    body: JSON.stringify(body)
  }).then(function(r){
    if (r.status === 202 || r.ok) return true;
    return r.json().catch(function(){ return {}; }).then(function(body){
      var err = new Error(path + ' ' + r.status);
      err.status = r.status;
      err.emailInvalid = (body.errors || []).some(function(item){
        return item.code === 'invalid' && item.source && item.source.pointer === '/data/attributes/profile/data/attributes/email';
      });
      throw err;
    });
  });
}

var zvUsBusy = false;
var zvUsDone = false;
function zvUsJoin(){
  if (zvUsBusy || zvUsDone) return;
  var email = document.getElementById('zvUsEmail').value.trim();
  var ageEl = document.getElementById('zvUsAge');
  var age = ageEl ? ageEl.value : '';
  var b = document.getElementById('zvUsJoin');
  zvUsSay('');
  if (!ZVPath.validEmail(email) || !document.getElementById('zvUsEmail').checkValidity()){ zvUsSay('Please enter a valid email address.'); return; }
  zvUsBusy = true;
  b.disabled = true; b.textContent = 'One moment…';

  var props = { signup_source: 'us-advertorial-how-much', market: 'US' };
  if (age) props.age_range = age;
  var source = ZVPath.snapshot();
  Object.assign(props, ZVPath.profileFields(source));

  // Both calls are required. /client/subscriptions/ sets consent and list membership but
  // writes NO properties onto a profile that already exists (proven 2026-08-11).
  // /client/profiles/ writes the fields on new and existing profiles alike.
  var subPayload = {
    data: {
      type: 'subscription',
      attributes: { profile: { data: { type: 'profile', attributes: { email: email, properties: props } } } },
      relationships: { list: { data: { type: 'list', id: ZVUS_LIST } } }
    }
  };
  var profPayload = { data: { type: 'profile', attributes: { email: email, properties: props } } };

  // Custom event so signups are countable as a metric.
  var evtPayload = {
    data: {
      type: 'event',
      attributes: {
        unique_id: ZVPath.eventId('waitlist'),
        properties: Object.assign({ age_range: age || 'not given', source: 'us-advertorial-how-much' }, ZVPath.eventFields(source)),
        metric: { data: { type: 'metric', attributes: { name: 'Joined US waitlist' } } },
        profile: { data: { type: 'profile', attributes: { email: email } } }
      }
    }
  };

  zvUsPost('subscriptions', subPayload)
    .then(function(){
      // Consent/list membership is already accepted. Optional attribution cannot undo it.
      return zvUsPost('profiles', profPayload).catch(function(){ return true; });
    })
    .then(function(){
      // The event is optional; never let it block the confirmation.
      return zvUsPost('events', evtPayload).catch(function(){ return true; });
    })
    .then(function(){
      zvUsDone = true;
      document.getElementById('zvUsForm').style.display = 'none';
      document.getElementById('zvUsNote').style.display = 'none';
      document.getElementById('zvUsOk').classList.add('show');
      try { if (typeof window.fbq === 'function') { if (window.ZVAM && typeof window.ZVAM.lead === 'function') { window.ZVAM.lead({}, { email: email }); } else { window.fbq('track','Lead'); } } } catch (ignore) {}
    })
    .catch(function(err){
      if (zvUsDone) return;
      zvUsBusy = false;
      b.disabled = false; b.textContent = 'Put me on the list';
      if (err.emailInvalid) {
        zvUsSay('Please check your email address and try again.');
      } else if (err.status === 429) {
        zvUsSay('Too many attempts. Please wait a minute before trying again.');
      } else {
        zvUsSay('We could not confirm your signup. Please try again, or contact support@zuvieskin.com if this continues.');
      }
    });
}

document.addEventListener('keydown', function(e){
  if (e.key === 'Enter' && document.activeElement && document.activeElement.id === 'zvUsEmail') zvUsJoin();
});

;

// Market-aware price. Do not type a figure into this page again.
(function(){
  var SYMBOL = { USD:'$', GBP:'£', EUR:'€' };
  var FIRST_PAINT = { USD:6900, GBP:4900 };
  var code = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
  function fmt(cents){
    var v = cents / 100;
    return (SYMBOL[code] || code + ' ') + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2));
  }
  function paint(cents){
    window.ZV_PRICE = fmt(cents);
    var n = document.querySelectorAll('.zv-price-auto');
    for (var i = 0; i < n.length; i++) n[i].textContent = window.ZV_PRICE;
  }
  if (FIRST_PAINT[code]) paint(FIRST_PAINT[code]);
  fetch('/products/the-pdrn-serum.js', { headers:{ 'Accept':'application/json' } })
    .then(function(r){ return r.ok ? r.json() : null; })
    .then(function(p){ if (p && typeof p.price === 'number') paint(p.price); })
    .catch(function(){});
})();

;

(function(){
  var KEY = "XNpMRQ";
  var SOURCE = "us-the-drawer-inline";
  var OK_ID = "zvUsOk";        /* the existing success block on this page */
  var EMAIL_ID = "zvUsEmail";  /* the existing email input on this page */

  var root = document.getElementById('zvDwqRoot');
  var ok = document.getElementById(OK_ID);
  if (!root || !ok) return;
  ok.appendChild(root);

  var DATA = null;
  fetch('/pages/the-drawer', { credentials: 'same-origin' })
    .then(function(r){ return r.ok ? r.text() : ''; })
    .then(function(h){
      var m = h.match(/<script[^>]*id="zv-drawer-data"[^>]*>([\s\S]*?)<\/script>/);
      if (m) { try { DATA = JSON.parse(m[1]); } catch (e) { DATA = null; } }
    })
    .catch(function(){ DATA = null; });

  function post(path, body){
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + KEY, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify(body)
    }).then(function(r){ if (r.status === 202 || r.ok) return true; throw new Error(path + ' ' + r.status); });
  }

  /* Pre-sort only. Nothing here decides what gets published — every answer is read
     before it appears on the page. This strips contact details and marks the rest. */
  var BRANDS = ["olay","estee","estée","lauder","clinique","neutrogena","cerave","cerarve","the ordinary","drunk elephant","paulas choice","paula's choice","la mer","lancome","lancôme","loreal","l'oreal","l'oréal","shiseido","sk-ii","skii","elemis","no7","no 7","roc ","rodan","fields","murad","kiehl","obagi","skinceuticals","skinmedica","tatcha","summer fridays","glow recipe","medik8","dermalogica","perricone","strivectin","nuface","beverly hills","proactiv","mary kay","avon","arbonne","rodial","charlotte tilbury","sunday riley","biossance","first aid beauty","peter thomas","dr jart","dr. jart","laneige","cosrx","beauty of joseon","anua","some by mi","innisfree","missha","rejuran","plinest","nucleofill"];

  function clean(raw){
    var t = String(raw || "").replace(/\s+/g, " ").trim();
    t = t.replace(/https?:\/\/\S+/gi, "").replace(/www\.\S+/gi, "");
    t = t.replace(/\S+@\S+\.\S+/g, "");
    t = t.replace(/[@#]\w+/g, "");
    t = t.replace(/\+?\d[\d\s().-]{7,}\d/g, "");
    t = t.replace(/\s+/g, " ").trim();
    if (t.length > 240) t = t.slice(0, 240).trim();
    var flags = [], low = " " + t.toLowerCase() + " ";
    for (var i = 0; i < BRANDS.length; i++){ if (low.indexOf(BRANDS[i]) > -1){ flags.push("brand"); break; } }
    var caps = t.slice(1).match(/(?:^|[^.!?]\s)([A-Z][a-z]{2,})/g);
    if (caps && caps.length && flags.indexOf("brand") === -1) flags.push("proper-noun");
    if (t.length < 8) flags.push("short");
    return { text: t, flags: flags.join(",") || "clean" };
  }

  function esc(s){ return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); }

  function reveal(){
    document.getElementById('zvDwqAsk').classList.remove('show');
    var lead = document.getElementById('zvDwqLead');
    var box = document.getElementById('zvDwqQuotes');
    var q = (DATA && DATA.quotes ? DATA.quotes.slice() : []);
    if (!q.length){
      lead.textContent = "That's in the drawer. You're one of the first — there's nothing to show you back yet.";
      box.innerHTML = '';
    } else {
      for (var i = q.length - 1; i > 0; i--){ var j = Math.floor(Math.random()*(i+1)); var t = q[i]; q[i] = q[j]; q[j] = t; }
      q = q.slice(0, 10);
      lead.textContent = DATA.count + ' answers were already in the drawer, counted ' + DATA.updated + '. Here are ten of them.';
      var html = '';
      for (var k = 0; k < q.length; k++){ html += '<p class="line">' + esc(q[k]) + '</p>'; }
      box.innerHTML = html;
    }
    document.getElementById('zvDwqDone').classList.add('show');
  }

  document.getElementById('zvDwqSend').addEventListener('click', function(){
    var el = document.getElementById('zvDwqText');
    var b = this;
    var errEl = document.getElementById('zvDwqErr');
    errEl.textContent = '';
    var emailEl = document.getElementById(EMAIL_ID);
    var email = emailEl ? emailEl.value.trim() : '';
    var c = clean(el.value);
    if (!c.text){ errEl.textContent = 'Write one line first.'; return; }
    if (!email){ errEl.textContent = "Something went wrong on our side. Please try again."; return; }
    b.disabled = true; b.textContent = 'One moment…';

    var props = { drawer_answer: c.text, drawer_flags: c.flags, drawer_status: 'pending', drawer_answered_at: new Date().toISOString(), drawer_source: SOURCE };
    post('profiles', { data: { type: 'profile', attributes: { email: email, properties: props } } })
      .then(function(){
        return post('events', { data: { type: 'event', attributes: {
          properties: { answer: c.text, flags: c.flags, status: 'pending', source: SOURCE },
          metric: { data: { type: 'metric', attributes: { name: 'Drawer answer' } } },
          profile: { data: { type: 'profile', attributes: { email: email } } }
        } } }).catch(function(){ return true; });
      })
      .then(reveal)
      .catch(function(){ b.disabled = false; b.textContent = 'Add it'; errEl.textContent = "That didn't save. Please try again."; });
  });

  function watch(){
    if (ok.classList.contains('show') || ok.offsetParent !== null){
      root.style.display = 'block';
      return true;
    }
    return false;
  }
  if (!watch()){
    var mo = new MutationObserver(function(){ if (watch()) mo.disconnect(); });
    mo.observe(ok, { attributes: true, attributeFilter: ['class', 'style'] });
  }
})();

;

(function(){
  var KEY = "XNpMRQ";
  var SOURCE = "us-the-drawer-inline";

  var root = document.getElementById('zvDwqRoot');
  var ok = document.getElementById('zvUsOk');
  var form = document.getElementById('zvUsForm');
  var note = document.getElementById('zvUsNote');
  var ask = document.getElementById('zvDwqAsk');
  var doneStep = document.getElementById('zvDwqDone');
  var send1 = document.getElementById('zvDwqSend');
  if (!root || !ok || !ask || !doneStep || !send1) return;

  /* True when Klaviyo already recognises this visitor — she clicked through from one of our
     own emails, or was identified in this browser before. She is on the list already, so she
     is not asked for her email again and no signup event is written. Answering is not signing up. */
  var KNOWN = false;
  var DATA = null;

  fetch('/pages/the-drawer', { credentials: 'same-origin' })
    .then(function(r){ return r.ok ? r.text() : ''; })
    .then(function(h){
      var m = h.match(/<script[^>]*id="zv-drawer-data"[^>]*>([\s\S]*?)<\/script>/);
      if (m) { try { DATA = JSON.parse(m[1]); } catch (e) { DATA = null; } }
    })
    .catch(function(){ DATA = null; });

  function post(path, body){
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + KEY, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify(body)
    }).then(function(r){ if (r.status === 202 || r.ok) return true; throw new Error(path + ' ' + r.status); });
  }

  var BRANDS = ["olay","estee","estée","lauder","clinique","neutrogena","cerave","cerarve","the ordinary","drunk elephant","paulas choice","paula's choice","la mer","lancome","lancôme","loreal","l'oreal","l'oréal","shiseido","sk-ii","skii","elemis","no7","no 7","roc ","rodan","fields","murad","kiehl","obagi","skinceuticals","skinmedica","tatcha","summer fridays","glow recipe","medik8","dermalogica","perricone","strivectin","nuface","beverly hills","proactiv","mary kay","avon","arbonne","rodial","charlotte tilbury","sunday riley","biossance","first aid beauty","peter thomas","dr jart","dr. jart","laneige","cosrx","beauty of joseon","anua","some by mi","innisfree","missha","rejuran","plinest","nucleofill"];

  function clean(raw){
    var t = String(raw || "").replace(/\s+/g, " ").trim();
    t = t.replace(/https?:\/\/\S+/gi, "").replace(/www\.\S+/gi, "");
    t = t.replace(/\S+@\S+\.\S+/g, "");
    t = t.replace(/[@#]\w+/g, "");
    t = t.replace(/\+?\d[\d\s().-]{7,}\d/g, "");
    t = t.replace(/\s+/g, " ").trim();
    if (t.length > 240) t = t.slice(0, 240).trim();
    var flags = [], low = " " + t.toLowerCase() + " ";
    for (var i = 0; i < BRANDS.length; i++){ if (low.indexOf(BRANDS[i]) > -1){ flags.push("brand"); break; } }
    var caps = t.slice(1).match(/(?:^|[^.!?]\s)([A-Z][a-z]{2,})/g);
    if (caps && caps.length && flags.indexOf("brand") === -1) flags.push("proper-noun");
    if (t.length < 8) flags.push("short");
    return { text: t, flags: flags.join(",") || "clean" };
  }

  function esc(s){ return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); }

  function email(){
    var el = document.getElementById('zvUsEmail');
    return el ? el.value.trim() : '';
  }

  /* A recognised visitor is written through Klaviyo's onsite tracking, which attaches to the
     profile it already knows — we never touch her address. Everyone else is written through
     the client API with the address she typed into the signup block above. */
  function write(props, metricName, evtProps){
    if (KNOWN && window.klaviyo && typeof window.klaviyo.track === 'function'){
      window.klaviyo.identify(props);
      window.klaviyo.track(metricName, evtProps);
      return Promise.resolve(true);
    }
    var addr = email();
    if (!addr) return Promise.reject(new Error('no address'));
    return post('profiles', { data: { type: 'profile', attributes: { email: addr, properties: props } } })
      .then(function(){
        return post('events', { data: { type: 'event', attributes: {
          properties: evtProps,
          metric: { data: { type: 'metric', attributes: { name: metricName } } },
          profile: { data: { type: 'profile', attributes: { email: addr } } }
        } } }).catch(function(){ return true; });
      });
  }

  /* Second question, built here so the block above stays untouched. */
  var step2 = document.createElement('div');
  step2.className = 'step';
  step2.id = 'zvDwq2';
  step2.innerHTML =
    '<p class="zv-step-label">Question 2 of 2</p>' +
    '<h3>And what made you keep using one?</h3>' +
    '<p class="sub">The harder question. If a bottle ever earned a second one, what did it?</p>' +
    '<textarea id="zvDwq2Text" maxlength="240" placeholder="I kept buying it because&#8230;"></textarea>' +
    '<button type="button" id="zvDwq2Send">Add it</button>' +
    '<button type="button" class="zv-skip2" id="zvDwq2Skip">Skip this one</button>' +
    '<p class="fine">Anonymous. Your name and email are never shown. Leave brand names out &#8212; I take them out anyway.</p>' +
    '<div class="err" id="zvDwq2Err"></div>';
  root.insertBefore(step2, doneStep);

  var label1 = document.createElement('p');
  label1.className = 'zv-step-label';
  label1.textContent = 'Question 1 of 2';
  ask.insertBefore(label1, ask.firstChild);

  function reveal(){
    ask.classList.remove('show');
    step2.classList.remove('show');
    var lead = document.getElementById('zvDwqLead');
    var box = document.getElementById('zvDwqQuotes');
    var q = (DATA && DATA.quotes ? DATA.quotes.slice() : []);
    if (!q.length){
      lead.textContent = "That's in the drawer. You're one of the first — there's nothing to show you back yet.";
      box.innerHTML = '';
    } else {
      for (var i = q.length - 1; i > 0; i--){ var j = Math.floor(Math.random()*(i+1)); var t = q[i]; q[i] = q[j]; q[j] = t; }
      q = q.slice(0, 10);
      lead.textContent = DATA.count + ' answers were already in the drawer, counted ' + DATA.updated + '. Here are ten of them.';
      var html = '';
      for (var k = 0; k < q.length; k++){ html += '<p class="line">' + esc(q[k]) + '</p>'; }
      box.innerHTML = html;
    }
    doneStep.classList.add('show');
  }

  /* Replace the original send button with a copy of itself. That drops the handler set by the
     block above, so the first answer now leads into the second question instead of straight to
     the end — without editing a single line of that block. */
  var fresh1 = send1.cloneNode(true);
  send1.parentNode.replaceChild(fresh1, send1);

  fresh1.addEventListener('click', function(){
    var el = document.getElementById('zvDwqText');
    var errEl = document.getElementById('zvDwqErr');
    errEl.textContent = '';
    var c = clean(el.value);
    if (!c.text){ errEl.textContent = 'Write one line first.'; return; }
    fresh1.disabled = true; fresh1.textContent = 'One moment…';

    var props = { drawer_answer: c.text, drawer_flags: c.flags, drawer_status: 'pending', drawer_answered_at: new Date().toISOString(), drawer_source: SOURCE };
    var evtProps = { answer: c.text, flags: c.flags, status: 'pending', source: SOURCE };

    write(props, 'Drawer answer', evtProps)
      .then(function(){
        ask.classList.remove('show');
        step2.classList.add('show');
        var t = document.getElementById('zvDwq2Text');
        if (t) t.focus();
      })
      .catch(function(){
        fresh1.disabled = false; fresh1.textContent = 'Add it';
        errEl.textContent = "That didn't save. Please try again.";
      });
  });

  document.getElementById('zvDwq2Send').addEventListener('click', function(){
    var b = this;
    var el = document.getElementById('zvDwq2Text');
    var errEl = document.getElementById('zvDwq2Err');
    errEl.textContent = '';
    var c = clean(el.value);
    if (!c.text){ errEl.textContent = 'Write one line first, or skip it.'; return; }
    b.disabled = true; b.textContent = 'One moment…';

    var props = { keeper_answer: c.text, keeper_flags: c.flags, keeper_status: 'pending', keeper_answered_at: new Date().toISOString(), keeper_source: SOURCE };
    var evtProps = { answer: c.text, flags: c.flags, status: 'pending', source: SOURCE, question: 'what made you keep using one' };

    write(props, 'Drawer keeper', evtProps)
      .then(reveal)
      .catch(function(){
        b.disabled = false; b.textContent = 'Add it';
        errEl.textContent = "That didn't save. Please try again, or skip it.";
      });
  });

  document.getElementById('zvDwq2Skip').addEventListener('click', reveal);

  /* Ask Klaviyo whether it already knows this visitor. klaviyo.js loads asynchronously,
     so wait for it rather than assuming it is there. */
  function goKnown(){
    if (KNOWN || email()) return;
    KNOWN = true;
    if (form) form.style.display = 'none';
    var t = ok.querySelector('.t');
    var p = ok.querySelector('p');
    if (t) t.textContent = "You're already on the list.";
    if (p) p.textContent = "So there's nothing to type twice. Two questions, if you have a moment.";
    ok.classList.add('show');
    root.style.display = 'block';
  }

  var tries = 0;
  var tick = function(){
    tries++;
    var k = window.klaviyo;
    if (k && typeof k.isIdentified === 'function'){
      try { k.isIdentified().then(function(yes){ if (yes) goKnown(); }).catch(function(){}); } catch (e) {}
      return;
    }
    if (tries < 40) setTimeout(tick, 150);
  };
  tick();
})();
